export const CIRCLE_SIZES_LOW_ZOOM = [3, 1000, 5, 5000, 7.5, 10000, 15]
export const CIRCLE_SIZES_HIGH_ZOOM = [12, 1000, 17, 5000, 23, 10000, 28]
